import Button from '../../ui/button';
import Modalcontainer from '../modalcontainer';
import styles from './styles.module.scss';
import { ReactComponent as OrtakSvg } from '../../assets/icons/Ortak.svg';

const OrtakRealtyModal = ({ cards, setShowOrtakPopup }: any) => {
  return (
    <Modalcontainer
      popupIconUri={'ortakLogo.svg'}
      backBtn={false}
      classNameBody={styles.ortakPopup}
      closePopup={() => setShowOrtakPopup(false)}
    >
      <div className={styles.popupContent}>
        <h1 className={styles.text}>UNLOCK THE FUTURE OF</h1>
        <h1 className={styles.text}> REAL ESTATE INVESTMENT</h1>
        <p className={styles.ortakRealtyText}>What is Ortak Realty</p>
        <p className={styles.ortakDescription}>
          ORTAK is transforming real estate investment by leveraging blockchain
          technology, allowing investors to seamlessly buy, sell, and trade
          digital assets backed by real-world properties.
        </p>
        <a href="https://ortak.me/en/real-estate" target="_blank">
          <Button size="md" color="categoryBtn" className={styles.btn}>
            Explore in Ortak
          </Button>
        </a>
      </div>

      <div className={styles.listContainer}>
        <div className={styles.list}>
          {!!cards.length &&
            cards.map((room: any, index: number) => {
              return (
                <div className={styles.ortakCard} key={`${room.id}_${index}`}>
                  {room.issuedBy === 1 && (
                    <div className={styles.ortakIcon}>
                      <OrtakSvg
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(room.websiteLink, '_blank');
                        }}
                      />
                    </div>
                  )}
                  <img
                    src={room.logo}
                    alt={room.name}
                    className={styles.ortakCardImage}
                  />
                  <div className={styles.info}>
                    <div className={styles.titleContainer}>
                      <p className={styles.title}>{room.name}</p>
                      {room.rewardPercentage && (
                        <div className={styles.percent}>
                          {room.rewardPercentage}%
                        </div>
                      )}
                    </div>
                    <div className={styles.descriptionContainer}>
                      {room.issuedBy === 1 && (
                        <div className={styles.nameDescContainer}>
                          <p className={styles.name}>Issued by: </p>{' '}
                          <span className={styles.description}>
                            Ortak Realty
                          </span>
                        </div>
                      )}
                      {room.reward != null && (
                        <div className={styles.nameDescContainer}>
                          <p className={styles.name}>Reward:</p>{' '}
                          <span className={styles.description}>
                            Ortak Realty
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Modalcontainer>
  );
};

export default OrtakRealtyModal;
